/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campaigns_Mag7_Fine_Print_AprInputs */

const en_campaigns_mag7_fine_print_apr = /** @type {(inputs: Campaigns_Mag7_Fine_Print_AprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reward APR is capped at 10% and may fall below depending on total balances on the platform.`)
};

const de_campaigns_mag7_fine_print_apr = /** @type {(inputs: Campaigns_Mag7_Fine_Print_AprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Prämien-APR ist auf 10 % begrenzt und kann abhängig vom Gesamtguthaben auf der Plattform niedriger ausfallen.`)
};

const pt_br2_campaigns_mag7_fine_print_apr = /** @type {(inputs: Campaigns_Mag7_Fine_Print_AprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O APR das recompensas é limitado a 10% e pode ser menor, dependendo do saldo total na plataforma.`)
};

const tr_campaigns_mag7_fine_print_apr = /** @type {(inputs: Campaigns_Mag7_Fine_Print_AprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödül APR’si %10 ile sınırlıdır ve platformdaki toplam bakiyeye bağlı olarak daha düşük olabilir.`)
};

const zh_cn2_campaigns_mag7_fine_print_apr = /** @type {(inputs: Campaigns_Mag7_Fine_Print_AprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`奖励年化收益率上限为 10%，并可能因平台总余额情况而低于该水平。`)
};

const zh_hk2_campaigns_mag7_fine_print_apr = /** @type {(inputs: Campaigns_Mag7_Fine_Print_AprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`獎賞年利率上限為 10%，並會視乎平台總結餘而可能低於此水平。`)
};

const ko_kr2_campaigns_mag7_fine_print_apr = /** @type {(inputs: Campaigns_Mag7_Fine_Print_AprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리워드 APR은 최대 10%이며, 플랫폼 전체 잔액에 따라 그보다 낮아질 수 있습니다.`)
};

const ru_ru2_campaigns_mag7_fine_print_apr = /** @type {(inputs: Campaigns_Mag7_Fine_Print_AprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ставка вознаграждения ограничена 10% годовых и может быть ниже в зависимости от совокупных балансов на платформе.`)
};

const es_419_campaigns_mag7_fine_print_apr = /** @type {(inputs: Campaigns_Mag7_Fine_Print_AprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El APR de las recompensas tiene un tope de 10% y puede ser menor según los saldos totales en la plataforma.`)
};

/**
* | output |
* | --- |
* | "Reward APR is capped at 10% and may fall below depending on total balances on the platform." |
*
* @param {Campaigns_Mag7_Fine_Print_AprInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_fine_print_apr = /** @type {((inputs?: Campaigns_Mag7_Fine_Print_AprInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Fine_Print_AprInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_fine_print_apr(inputs)
	if (locale === "de") return de_campaigns_mag7_fine_print_apr(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_fine_print_apr(inputs)
	if (locale === "tr") return tr_campaigns_mag7_fine_print_apr(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_fine_print_apr(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_fine_print_apr(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_fine_print_apr(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_fine_print_apr(inputs)
	return es_419_campaigns_mag7_fine_print_apr(inputs)
});